@use '@fukuri-admins/ui/layout' as *;

.svgIcon {
  display: block; // inline による余分な空白防止（legacy では <span> 内の svg に設定されていた）
  color: text('High'); // currentColor の基準色。legacy では <span> ラッパーで設定されていた
}
